import { toValue } from 'vue'
import { defineStore } from 'pinia'
import Project from '@/classes/projects/Project'
import Update from '@/classes/updates/Update'
import PublicProcedureExecutions from '@/classes/procedure_executions/PublicProcedureExecutions'
import { get as _get } from 'lodash'

const models = { project: Project, update: Update, public_procedure_executions: PublicProcedureExecutions }

export const useSampleStore = defineStore('SampleStore', {
  state: () => ({
    sample: {},
    samples: {},
    loader: false,
    error: {}
  }),
  getters: {
    getSample: state => ({ id }) => state.$getItem({
      resource: 'sample',
      key: id,
      fetch: () => state.fetchSample({ id })
    }),
    getSamples: state => ({ id, query }) => state.$getItems({
      resource: 'samples',
      query,
      fetch: () => state.fetchSamples({ id, query })
    })
  },
  actions: {
    async fetchSample ({ id }) {
      await this.$pipeline({ dependencies: [id] })

      return this.$fetchItem({
        endpoint: `/api/v1/samples/${toValue(id)}`,
        resource: `sample.${toValue(id)}`,
        model: _get(models, toValue(id), null)
      })
    },
    async fetchSamples ({ id, query }) {
      await this.$pipeline({ dependencies: [id] })

      return this.$fetchItems({
        endpoint: `/api/v1/samples/${toValue(id)}`,
        resource: 'samples',
        model: _get(models, toValue(id), null),
        query
      })
    }
  }
})